/** @jsxImportSource @emotion/react */
import { Box, Button, Container } from '@mui/material'
import { useNavigate } from 'react-router-dom'

import DatasetList from '../components/DatasetList'
import { pageWrapper, container, formWrapper } from '../components/DataUpload.styles'
import { GuidePageHeader } from '@app/modules/GuideV2/components/GuidePageHeader'

const DatasetListPage = () => {
  const navigate = useNavigate()

  return (
    <Box css={pageWrapper}>
      <Box css={container}>
        <GuidePageHeader header="Element Data Upload" subheader="Select a dataset to edit" />
        <Box css={formWrapper}>
          <Container>
            <Button variant="text" onClick={() => navigate(-1)} sx={{ mb: 2, pl: 0 }}>
              ← Back
            </Button>
            <DatasetList
              onSelect={(row) => navigate(`/app/home/data-upload/edit/${row.library_id}`)}
            />
          </Container>
        </Box>
      </Box>
    </Box>
  )
}

export default DatasetListPage
